import React from 'react';
import FetchContext from './components/fetch-context';
import TransitionRouter from './routes';
import { AppState } from './reducers';
import { useAppContext } from 'src/components/app-context';
import routeConfig from './routes/config';
import { useSelector } from 'react-redux';

export const AppTransitionRouter: React.FC = () => {
  const { market } = useAppContext();
  const TRouter: any = TransitionRouter; // Typing as any until TransitionRouter can become Typescript - The 'old' withRouter has poor typing support
  const user = useSelector((state: AppState) => state.areas.user);
  const isAuthenticated = useSelector(
    (state: AppState) => state.areas.account.isAuthenticated
  );
  const campaigns = useSelector((state: AppState) => state.globals.campaigns);

  return (
    <FetchContext.Consumer>
      {(fetchContext: any) => {
        return (
          <TRouter
            loaderAfter={1500}
            fetchContext={fetchContext}
            campaigns={campaigns}
            routes={market.routes}
            personalizationClientId={
              user && user.personalization && user.personalization.clientId
            }
            pulseEnvironmentId={
              user &&
              user.personalization &&
              user.personalization.pulseEnvironmentId
            }
            isAuthenticated={isAuthenticated}
            routeConfig={routeConfig}
          />
        );
      }}
    </FetchContext.Consumer>
  );
};
